import { ToastModule } from 'primeng/toast';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from './app/services/auth.service';
import { LoginResponseDto } from './app/shared/models/auth.model';
import { Title } from '@angular/platform-browser';
import { environment } from './environments/environment';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule, ToastModule],
  template: `
    <p-toast></p-toast>
    <router-outlet></router-outlet>
  `
})
export class AppComponent {
  private authService = inject(AuthService);
  private titleService = inject(Title);
  private document = inject(DOCUMENT);

  ngOnInit(): void {
    this.setCurrentUser();
    this.titleService.setTitle(environment.companyName);
    this.setFavicon(environment.favicon);
  }

  setFavicon(faviconPath: string) {
    const link: HTMLLinkElement | null = this.document.querySelector("link[rel*='icon']");
    if (link) {
      link.href = `/${faviconPath}`;
    } else {
      const newLink = this.document.createElement('link');
      newLink.rel = 'icon';
      newLink.href = `/${faviconPath}`;
      this.document.head.appendChild(newLink);
    }
  }

  setCurrentUser() {
    const loginResponseDto: LoginResponseDto = JSON.parse(localStorage.getItem('user') || '{}');
    if (loginResponseDto) {
      this.authService.currentUser.set(loginResponseDto);
    }
  }
}
